export function toggleFieldWarning(field, toggle, message) {
    let label, span;
    // TODO refactor and remove custom function
    if (
        field.hasAttribute("data-custom-warning") &&
        typeof customToggleFieldWarning === "function"
    ) {
        customToggleFieldWarning(field, toggle, message);
    } else {
        label = document.querySelector("label[for=" + field.id + "]");
        span = label.querySelector("span.warning");
        field.classList[toggle ? "add" : "remove"]("warning");
        label.classList[toggle ? "add" : "remove"]("warning");
        span.innerHTML = toggle ? message : "";
    }
}
